export default {"src":"/_next/static/media/Idaho.0ef2ee16.svg","height":905,"width":800,"blurWidth":0,"blurHeight":0};